import { CandidateEducationClass } from '../job-offer/job-offer-candidate-education.model';
import { CandidateLanguagesSkillsClass } from '../job-offer/job-offer-candidate-languages.model';
import { CreateCandidateOtherSkillsClass } from './create-candidate-other-skills.model';
export class CreateCandidateQualificationsClass {
    candidateEducation?: CandidateEducationClass;
    candidateLanguages?: CandidateLanguagesSkillsClass;
    candidateOtherSkills?: CreateCandidateOtherSkillsClass;
}
